export default __webpack_public_path__ + "static/city-of-driggs-logo-white-e555b74a3fc645576f5b714677868813.svg";